module.exports = __webpack_public_path__ + "static/media/spinner.260f3a21.svg";